import { connect } from 'react-redux';

import PageOne from './PageOne';

export default connect(
  ({
    journeyBuilderArea: {
      JourneyBuilderSettings: {
        payload: { outcomes },
        readonlyForm,
      },
    },
  }) => ({
    outcomes,
    readonlyForm,
  })
)(PageOne);



// WEBPACK FOOTER //
// ./src/JourneyBuilder/DecisionSplit/components/PageOneContainer.js